import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FONTS } from 'styles/theme';

const POPOVER_WIDTH = 220;
const EDGE = 8;

// A span, not a button, because it sits inside clickable tabs and calendar cells.
const InfoHint = ({ text, size }) => {
    const iconRef = useRef(null);
    const popoverRef = useRef(null);
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (!position) return undefined;
        const close = (e) => {
            if (iconRef.current?.contains(e.target) || popoverRef.current?.contains(e.target)) return;
            setPosition(null);
        };
        const dismiss = () => setPosition(null);
        document.addEventListener('pointerdown', close);
        window.addEventListener('scroll', dismiss, true);
        window.addEventListener('resize', dismiss);
        return () => {
            document.removeEventListener('pointerdown', close);
            window.removeEventListener('scroll', dismiss, true);
            window.removeEventListener('resize', dismiss);
        };
    }, [position]);

    const toggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (position) {
            setPosition(null);
            return;
        }
        const rect = iconRef.current.getBoundingClientRect();
        const left = Math.min(
            Math.max(EDGE, rect.left + rect.width / 2 - POPOVER_WIDTH / 2),
            window.innerWidth - POPOVER_WIDTH - EDGE,
        );
        setPosition({ top: rect.bottom + 6, left });
    };

    return (
        <>
            <span
                ref={iconRef}
                role="button"
                tabIndex={0}
                aria-label="More info"
                aria-expanded={!!position}
                onClick={toggle}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggle(e); }}
                style={{ fontSize: size, padding: '2px', margin: '-2px', cursor: 'pointer', lineHeight: 1 }}
            >
                ⓘ
            </span>
            {position && createPortal(
                <div
                    ref={popoverRef}
                    role="tooltip"
                    style={{
                        position: 'fixed', top: position.top, left: position.left, width: `${POPOVER_WIDTH}px`,
                        zIndex: 1100, padding: '8px 10px', borderRadius: '8px', backgroundColor: '#2B2118', color: '#fff',
                        fontFamily: FONTS.sans, fontSize: '12px', fontWeight: 400, lineHeight: 1.4,
                        letterSpacing: 'normal', textTransform: 'none', textAlign: 'left',
                        boxShadow: '0 6px 18px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    {text}
                </div>,
                document.body,
            )}
        </>
    );
};

export default InfoHint;
